<template>
  <div class="switch-wrap-plus gray-30-bg">
    <div class="switch">
      <span v-for="(item, index) in switchOptions" :key="index" @click="toggle(item)" :class='sel === item.value ? "circleChecked blue-bg white-cl" : "circleCheckOut gray-cl"'>{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-switch-plus',
  data() {
    return {
      sel: this.value,
      defaultOptions: [
        { label: this.$t('futures.order.yes'), value: true },
        { label: this.$t('futures.order.no'), value: false },
      ],
    };
  },
  props: {
    // options
    options: {
      type: Array,
      default: () => [],
    },
    // 控制开关开启关闭
    value: {
      type: [Boolean, String, Number],
      default: true,
    },
  },
  computed: {
    switchOptions() {
      return this.options && this.options.length ? this.options : this.defaultOptions;
    },
  },
  watch: {
    value(val) {
      this.sel = val;
    },
    sel(val) {
      this.$emit('change', val);
    },
  },
  methods: {
    toggle(item) {
      this.sel = item.value;
    },
  },
};
</script>

<style lang='scss' scoped>
.switch-wrap-plus{
  font-family: 'Alpex';
  font-style: normal;
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 28px;
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
  line-height: 20px;

  .switch {
    span {
      font-size: 12px;
      line-height: 16px;
      margin: 0 10px;
    }
  }

  .circleChecked{
    margin: 0 !important;
    padding: 2px 10px;
    border-radius: 3px;
    // transform: translateX(12px);
    // transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }

  .circleCheckOut{
    transform: translateX(0);
    transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
}
</style>
